/* eslint-disable react/destructuring-assignment */
import { GridColDef } from "@mui/x-data-grid-pro";
import { GKDataGrid, Grid2, Tooltip, Typography } from "components";
import useGenerateQueryParams from "hooks/useGenerateQueryParams";
import { useFetchQuery } from "hooks/useQueries";
import { moneyCommaSeparator } from "utils";
import { extraColumnsField, matchDate } from "utils/helpers";
import { handleReturnTripleDots } from "utils/StringFunctions";
import useDocumentTitle from "utils/useDocumentTitle";

interface Props {
  id: string;
}

const ClientTab = (props: Props) => {
  useDocumentTitle("Partner Portfolios");

  const { id } = props;

  const requestBody = useGenerateQueryParams("partnerClient");

  const { data, isFetching } = useFetchQuery({
    key: ["PARTNER_BY_PORTFOLIOS", requestBody],
    route: `/partner/${id}/portfolio_list/`,
    requestBody,
  });

  // const PortfolioDetailTable = (params: GridRowParams) => {
  //   const { row } = params;

  //   const columns: GridColDef[] = [
  //     {
  //       ...extraColumnsField("Portfolio Name / Code", "clientName", 250, 1),
  //       valueGetter: (params) => `${params?.row?.name} / ${params?.row?.code}`,
  //     },
  //     {
  //       ...extraColumnsField("Fee Plan", "feePlan", 150, 1),
  //       valueGetter: (row) => row?.row?.feePlan || "-",
  //     },
  //     {
  //       ...extraColumnsField("Sharing Structure", "sharingStructure", 150, 1),
  //       valueGetter: (row) => row?.row?.sharingStructure || "-",
  //     },
  //     {
  //       ...extraColumnsField("Billing Date", "billingDate", 150, 1),
  //       valueGetter: (row) => matchDate(row?.row?.billingDate),
  //     },
  //   ];

  //   return (
  //     <Grid2 container p={2}>
  //       <Grid2 size={12}>
  //         <GKClientDataGrid
  //           name="partnerClient"
  //           showHeaderGrid={false}
  //           columnsButton={false}
  //           columns={columns}
  //           rows={row?.portfolios || []}
  //         />
  //       </Grid2>
  //     </Grid2>
  //   );
  // };

  const columns: GridColDef[] = [
    {
      ...extraColumnsField("Portfolio", "clientName", 250, 1),
      renderCell: (params) => {
        const portfolioNameCode = `${params?.row?.portfolioName} - ${params?.row?.portfolioId}`;

        return (
          <Grid2 container justifyContent={"flex-start"} size={12}>
            <Tooltip title={portfolioNameCode}>
              <Grid2 size={12}>
                <Typography fontWeight={700}>
                  {handleReturnTripleDots({
                    str: params?.row?.clientName,
                    length: 25,
                  })}
                </Typography>
                <Typography fontSize={12}>
                  {handleReturnTripleDots({ str: portfolioNameCode })}
                </Typography>
              </Grid2>
            </Tooltip>{" "}
          </Grid2>
        );
      },
    },
    {
      ...extraColumnsField("Portfolio Value", "portfolioValue", 150, 1),
      type: "number",
      valueGetter: (row) => row?.row?.portfolioValue,
      valueFormatter: (params) => moneyCommaSeparator(params.value) || 0,
    },
    {
      ...extraColumnsField("XIRR", "xirr", 80, 1),
      type: "number",
      valueGetter: (row) => row?.row?.xirr,
      valueFormatter: (params) => moneyCommaSeparator(params.value) || 0,
    },
    {
      ...extraColumnsField("Fee Plan", "feePlan", 200, 1),
      valueGetter: (row) => row?.row?.feePlan || "-",
    },
    {
      ...extraColumnsField("Billed Revenue", "billedRevenue", 150, 1),
      type: "number",
      valueGetter: (row) => row?.row?.billedRevenue,
      valueFormatter: (params) => moneyCommaSeparator(params.value) || 0,
    },
    {
      ...extraColumnsField("Commission Amount", "commissionAmount", 170, 1),
      type: "number",
      valueGetter: (row) => row?.row?.commissionAmount,
      valueFormatter: (params) => moneyCommaSeparator(params.value) || 0,
    },
    {
      ...extraColumnsField("Billing Date", "billingDate", 150, 1),
      valueGetter: (row) => matchDate(row?.row?.billingDate),
    },
    {
      ...extraColumnsField("Sharing Structure", "sharingStructure", 170, 1),
      valueGetter: (row) => row?.row?.sharingStructure || "-",
    },
  ];

  return (
    <GKDataGrid
      loading={isFetching}
      rows={data?.data?.data || []}
      columns={columns}
      getRowId={(row) => row?.portfolioId}
      maxHeight={"calc(100vh - 321px)"}
      totalCount={data?.data?.totalCount || 0}
      zeroHolding
      name="partnerClient"
      tableName="partner_client_list"
    />
  );
};

export default ClientTab;
